module.exports = __webpack_public_path__ + "static/media/crocodile.ad84e35e.svg";